// Stocktake screens (Warehouse count flow + Approvals board) — colour aliases that mirror the
// admin panel's MUI DEFAULT theme, so these pages match the rest of the app instead of a bespoke
// palette. The app has no custom ThemeProvider, so "the standard" is MUI v7's default palette; each
// token below is the corresponding default value (text.*, divider, success/warning/error/info.*).
// Prefer MUI palette tokens (color="text.secondary", <Chip color="success">, borderColor:'divider')
// in new code — these aliases exist so the existing template-literal borders keep resolving to real
// CSS colours while the pages converge on the standard look.
export const stk = {
  // Ink & lines → MUI text.* and divider
  ink: 'rgba(0, 0, 0, 0.87)', // text.primary
  inkSoft: 'rgba(0, 0, 0, 0.6)', // text.secondary
  line: 'rgba(0, 0, 0, 0.12)', // divider
  lineStrong: 'rgba(0, 0, 0, 0.23)', // default input outline
  slateBg: '#f9f9f9', // neutral row/zebra surface (matches DataGrid striping)
  canvas: '#ffffff', // page background = default white (no more grey sheet)
  field: '#fafafa', // subtle untouched-row fill

  // Semantic tones → MUI success / warning / error / primary (main + light-bg + light-border)
  green: '#2e7d32', // success.main
  greenBg: '#edf7ed', // success alert background
  greenLine: '#a5d6a7', // success light border
  amber: '#ed6c02', // warning.main
  amberBg: '#fff4e5', // warning alert background
  amberLine: '#ffb74d', // warning light border
  red: '#d32f2f', // error.main
  redBg: '#fdeded', // error alert background
  redLine: '#ef9a9a', // error light border
  blue: '#1976d2', // primary.main
  blueBg: '#e3f2fd', // primary light background
  blueLine: '#90caf9', // primary light border

  // Type → default MUI font family (no monospace anywhere else in the app)
  mono: '"Roboto","Helvetica","Arial",sans-serif',
} as const;
